import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "./client";

/** Unlimited, as the API expresses it — a value rather than a missing field. */
export const UNLIMITED = -1;

/**
 * What the household's plan still allows this month (`project.md` §1, K-35).
 *
 * A limit somebody first learns about when it fires feels arbitrary whatever
 * number it holds. This is what lets a screen count down to one instead.
 */
export interface Allowance {
  plan: string;
  accounts: number;
  account_limit: number;
  transactions_this_month: number;
  transaction_limit: number;
  transactions_remaining: number;
  imports_run: number;
  can_import: boolean;
}

export const allowanceQueryKey = (householdId: string) =>
  ["households", householdId, "allowance"] as const;

export function useAllowance(householdId: string | undefined) {
  return useQuery({
    queryKey: allowanceQueryKey(householdId ?? ""),
    queryFn: ({ signal }) =>
      apiFetch<Allowance>(`/api/v1/households/${householdId}/allowance`, { signal }),
    enabled: Boolean(householdId),
  });
}

/**
 * Whether the count is worth putting in front of somebody.
 *
 * Not at 50 of 50 remaining — that is a number nobody needs and a nag about a
 * limit they are nowhere near. `project.md` §5.5 wants the interface calm; a
 * plan limit earns its place on screen when it is close enough to change what
 * somebody does.
 */
export function shouldShowRemaining(allowance: Allowance | undefined): boolean {
  if (!allowance || allowance.transaction_limit === UNLIMITED) return false;
  return allowance.transactions_remaining <= 10;
}
